import React from "react";
import { useLanguage } from "../../../i18n";
import "./About.css";

const About = () => {
  const { t } = useLanguage();
  const values = t("about.values");

  return (
    <section className="about">
      <div className="about-container">
        <h2 className="about-title">{t("about.title")}</h2>
        <p className="about-text">
          <strong>Fixanor Software Solutions S.R.L.</strong> {t("about.intro.before")}{" "}
          <span className="highlight">{t("about.intro.websites")}</span>{" "}
          {t("about.intro.between")}{" "}
          <span className="highlight">{t("about.intro.webApplications")}</span>
          {t("about.intro.after")}
        </p>

        <p className="about-text">
          {t("about.philosophyPrefix")} <em>"{t("about.philosophyQuote")}" </em>
        </p>

        <p className="about-text">
          {t("about.approach")}
        </p>

        <div className="about-values">
          {values.map((value) => (
            <div className="value-card" key={value.title}>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>

        <p className="about-text">
          {t("about.closing")}
        </p>
      </div>
    </section>
  );
};

export default About;
